// Сервер стал возвращать лого как base64 (image + image_type) вместо готовой image_url.
// Добавляем image_url на лету, чтобы компоненты, читающие paymentDetails?.image_url, не менялись.
export const attachImageUrl = (data) => {
  if (!data || !data.image) return data;

  return {
    ...data,
    image_url: `data:${data.image_type || "image/png"};base64,${data.image}`,
  };
};
